import styled, { css } from 'styled-components'
import Box from '@components/Box'
import { above } from '@styles/mixins/breakpoints'
import { SH3, SParagraph } from '@components/Typography'
import { SWideButton } from '@components/Benefits/Card'
import { colors } from '@styles/theme'

export const SContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  padding-bottom: 20px;
`

export const SStep = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  padding: 0 20px;

  &:last-of-type {
    margin-right: 0;
  }

  ${above('md')(css`
    flex-shrink: unset;
    flex-grow: unset;
    width: 382px;
    padding: 0;
    margin-right: 80px;

    &:first-of-type {
      width: 210px;
    }

    &:last-of-type {
      width: 282px;
    }
  `)}

  ${above('xl')(css`
    margin-right: 140px;
  `)}
`

export const SSubTitle = styled(SH3)`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 12px;
`

export const SText = styled(SParagraph)`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 24px;
`

export const SButton = styled(SWideButton)`
  &:hover {
    border-color: ${colors.darkBlue};
    background-color: ${colors.darkBlue};
  }

  ${above('md')(css`
    width: 126px;
  `)}
`
